import { render, staticRenderFns } from "./TableDataBanner.vue?vue&type=template&id=102853b3&"
import script from "./TableDataBanner.vue?vue&type=script&lang=js&"
export * from "./TableDataBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports